import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CatalogRef } from "./CatalogRef";
import type { CatalogStaff } from "./CatalogStaff";
import type { CatalogTaxDTOBase } from "./CatalogTaxDTOBase";
import type { TrackedModernBase } from "./TrackedModernBase";

export class CatalogTaxStaff implements CatalogTaxDTOBase, TrackedModernBase {
  constructor(public readonly assignId: number, public readonly catalogId: CatalogStaff | null, public readonly taxName: string, public readonly taxRate: string | null, public readonly taxMinValueCents: number | null, public readonly taxCode: string | null, public readonly taxAmountFixedCents: number | null, public readonly taxBeforeDiscount: boolean | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly catalogIdTargetIds: CatalogRef) {
    this.cbiServiceContext = null;
    this.catalogIdLoaded = this.catalogId != null;
    this.catalogIdCached = this.catalogId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private catalogIdLoaded: boolean;
  private catalogIdCached: CatalogStaff | null;
  async catalogIdLazy(): Promise<CatalogStaff> {
    if (!this.catalogIdLoaded) {
      this.catalogIdCached = await this.cbiServiceContext!.catalogService().getCatalogStaff(this.catalogIdTargetIds.assignId);
      this.catalogIdLoaded = true;
    }
    return this.catalogIdCached!;
  }
}
